export default "__VITE_ASSET__8pS2L7pu__"